<nz-date-picker nzShowTime nzFormat="dd/MM/yyyy HH:mm"
    [(ngModel)]="data"
    [ngClass]="inputCss"
    [nzDisabledDate]="disabledDate"
    [nzDisabledTime]="disabledTime"
    (ngModelChange)="onChange($event)">
</nz-date-picker>
